<svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 cursor-help text-gray-400" viewBox="0 0 24 24" fill="currentColor"
  (mouseenter)="show($event)" (mouseleave)="hide()" (click)="toggle($event)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2a10 10 0 100 20 10 10 0 000-20Zm-.88 6.25a.88.88 0 1 1 1.76 0 .88.88 0 0 1-1.76 0ZM11 11h1.25c.55 0 1 .45 1 1v4.25a1 1 0 1 0 2 0V12a3 3 0 0 0-3-3H11a1 1 0 1 0 0 2Z"/>
</svg>

@if (position(); as pos) {
<div class="pointer-events-none fixed z-999999 w-56 -translate-x-1/2 -translate-y-full rounded-lg bg-gray-900 px-2.5 py-1.5 text-xs font-normal normal-case text-white shadow-lg dark:bg-gray-700"
  [style.top.px]="pos.top - 8" [style.left.px]="pos.left">
  <ng-content></ng-content>
</div>
}
